import { render } from "./EventRoleModel.vue?vue&type=template&id=21a78334"
import script from "./EventRoleModel.vue?vue&type=script&lang=js"
export * from "./EventRoleModel.vue?vue&type=script&lang=js"

import "./EventRoleModel.vue?vue&type=style&index=0&id=21a78334&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__